import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {CommunicationContentModelModel} from '../../../api/entity/communicationContentModel.model';

@Injectable()
export class CommunicationContentModelRepository extends AbstractRepositoryV2<CommunicationContentModelModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('CommunicationContentModel', serviceElementsFactory, injector);
    }
}
